import { __assign } from "tslib";
import * as React from 'react';
import { LazyMotion, domAnimation } from 'framer-motion';
import { ThemeProvider } from 'styled-components';
export { useReactTreeApi } from './hooks/useReactTreeApi';
import ReactTreeContext from './Tree/Context';
import TreeRoot from './Tree/TreeRoot';
import coreTheme from './styles/theme';
export var ReactTree = React.forwardRef(function (_a, ref) {
    var _b = _a.nodes, nodes = _b === void 0 ? [] : _b, defaultOpenNodes = _a.defaultOpenNodes, defaultSelectedNodes = _a.defaultSelectedNodes, selectedNodes = _a.selectedNodes, openNodes = _a.openNodes, _c = _a.messages, messages = _c === void 0 ? {
        loading: 'Loading...',
        noData: 'No data to render 😔',
        emptyItems: '[Empty]'
    } : _c, _d = _a.loading, loading = _d === void 0 ? false : _d, _e = _a.theme, theme = _e === void 0 ? 'light' : _e, themes = _a.themes, _f = _a.enableIndicatorAnimations, enableIndicatorAnimations = _f === void 0 ? false : _f, _g = _a.enableItemAnimations, enableItemAnimations = _g === void 0 ? false : _g, _h = _a.showEmptyItems, showEmptyItems = _h === void 0 ? false : _h, _j = _a.noIcons, noIcons = _j === void 0 ? false : _j, _k = _a.truncateLongText, truncateLongText = _k === void 0 ? false : _k, _l = _a.multiSelect, multiSelect = _l === void 0 ? false : _l, containerStyles = _a.containerStyles, RenderNode = _a.RenderNode, RenderIcon = _a.RenderIcon, onToggleSelectedNodes = _a.onToggleSelectedNodes, onToggleOpenNodes = _a.onToggleOpenNodes;
    /**
     * Complete react-tree theme
     */
    var config = React.useMemo(function () {
        return {
            themes: __assign(__assign({}, coreTheme.themes), themes),
            app: coreTheme.app
        };
    }, [themes]);
    return (React.createElement(ThemeProvider, { theme: config },
        React.createElement(LazyMotion, { features: domAnimation },
            React.createElement(ReactTreeContext.Provider, { nodes: nodes, defaultOpenNodes: defaultOpenNodes, defaultSelectedNodes: defaultSelectedNodes, options: {
                    folderAnimations: enableItemAnimations,
                    indicatorAnimations: enableIndicatorAnimations,
                    lazy: false,
                    showEmptyItems: showEmptyItems,
                    noIcons: noIcons,
                    truncateLongText: truncateLongText,
                    multiSelect: multiSelect,
                    messages: messages
                }, theme: theme, apiRef: ref, openNodes: openNodes, selectedNodes: selectedNodes, onToggleOpenNodes: onToggleOpenNodes, onToggleSelectedNodes: onToggleSelectedNodes },
                React.createElement(TreeRoot, { loading: loading, containerStyles: containerStyles, RenderNode: RenderNode, RenderIcon: RenderIcon })))));
});
//# sourceMappingURL=index.js.map